module.exports = __webpack_public_path__ + "media/images/products/banners/total_return_portfólio-c9de03937a6fe1d9f65e8b745accb269.png";